import { Check } from "lucide-react";

const CyberRisksFeatures = () => {
  const risks = [
    { name: "Ransomware", damage: "85.000 €" },
    { name: "Phishing-Attacken", damage: "25.000 €" },
    { name: "DSGVO-Verstöße", damage: "20 Mio. €" },
    { name: "Datenverlust", damage: "45.000 €" },
    { name: "Betriebsausfall", damage: "3.500 €/Tag" },
    { name: "Supply-Chain", damage: "35.000 €" }
  ];

  return (
    <section className="py-20 sm:py-28 lg:py-32 relative">
      {/* Dezenter Gradient Overlay */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: "radial-gradient(ellipse at center, hsl(var(--destructive) / 0.08), transparent 70%)"
        }}
      />
      
      <div className="container max-w-5xl mx-auto px-6 sm:px-8 relative z-10">
        
        {/* Header - zentriert */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Die 6 größten <span className="text-destructive">Cyber-Bedrohungen</span>
          </h2>
          <p className="text-xl sm:text-2xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Diese Gefahren bedrohen Ihre Praxis täglich
          </p>
        </div>
        
        {/* Liste - zentriert, 2-spaltig auf Desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {risks.map((risk, idx) => (
            <div key={idx} className="flex items-start gap-4 border border-white/10 rounded-xl p-6 backdrop-blur-sm hover:border-accent/30 transition-all">
              <Check className="w-6 h-6 text-accent flex-shrink-0 mt-1" />
              <div className="flex-1">
                <div className="flex items-baseline justify-between gap-4">
                  <span className="font-bold text-foreground text-lg">{risk.name}</span>
                  <span className="text-destructive font-bold text-lg whitespace-nowrap">{risk.damage}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CyberRisksFeatures;
